import {Route} from "@angular/router";
import {PrivateLayout} from "@layouts/private/private.layout";
import { authGuard } from '@guards/auth.guard';

export const routes: Route[] = [
  {
    path: 'a',
    component: PrivateLayout,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('@components/pages/private/overview/overview.component').then(m => m.OverviewComponent),
        title: 'Dashboard'
      },
      {
        path: 'profile',
        loadComponent: () => import('@components/pages/private/profile/profile.component').then(m => m.ProfileComponent),
        title: 'Your profile'
      },
      {
        path: 'accounts/:accountId',
        loadComponent: () => import('@components/pages/private/account-details/account-details.component').then(m => m.AccountDetailsComponent),
        title: 'Account details'
      },
      {
        path: 'partners/lookup',
        redirectTo: 'partners',
        pathMatch: 'full'
      },
      {
        path: 'partners',
        loadComponent: () => import('@components/pages/private/partners/partners.component').then(m => m.PartnersComponent),
        title: 'Partners'
      },
      {
        path: 'users',
        loadComponent: () => import('@components/pages/private/users/users.component').then(m => m.UsersComponent),
        title: 'Users'
      },
      {
        path: 'statements',
        loadComponent: () => import('@components/pages/private/statements/statements.component').then(m => m.StatementsComponent),
        title: 'Account statements'
      },
      {
        path: 'help',
        loadComponent: () => import('@components/pages/private/help/help.component').then(m => m.HelpComponent),
        title: 'Help & support'
      }
    ]
  }
]
